import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
import { footerQuickLinks } from '../../data/navigation';
import { companyInfo, aboutText } from '../../data/company';
import BetaLink from '../../beta/BetaLink';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">

          {/* About Us */}
          <div>
            <h3 className="text-white text-lg font-semibold mb-4 uppercase tracking-wide">
              About Us
            </h3>
            <p className="text-sm leading-relaxed">
              {aboutText.short}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white text-lg font-semibold mb-4 uppercase tracking-wide">
              Quick Links
            </h3>
            <ul className="space-y-2">
              {footerQuickLinks.map((link) => (
                <li key={link.href}>
                  <BetaLink
                    to={link.href}
                    className="text-sm hover:text-primary-red transition-colors"
                  >
                    {link.label}
                  </BetaLink>
                </li>
              ))}
            </ul>
          </div>

          {/* Our Location */}
          <div>
            <h3 className="text-white text-lg font-semibold mb-4 uppercase tracking-wide">
              Our Location
            </h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <Phone size={16} className="mt-1 flex-shrink-0" />
                <span>Phone: {companyInfo.phone}</span>
              </li>
              <li className="flex items-start gap-2">
                <Phone size={16} className="mt-1 flex-shrink-0" />
                <span>Fax: {companyInfo.fax}</span>
              </li>
              <li className="flex items-start gap-2">
                <Mail size={16} className="mt-1 flex-shrink-0" />
                <a
                  href={`mailto:${companyInfo.email}`}
                  className="hover:text-primary-red transition-colors"
                >
                  {companyInfo.email}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin size={16} className="mt-1 flex-shrink-0" />
                <span>
                  {companyInfo.name}<br />
                  {companyInfo.location}
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Copyright Bar */}
      <div className="border-t border-gray-800 py-4">
        <div className="max-w-7xl mx-auto px-6 text-center text-xs text-gray-500">
          <p>&copy; {new Date().getFullYear()} {companyInfo.name}. All rights reserved.</p>
        </div>
      </div>

      {/* Back to Top Button */}
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        className="fixed bottom-6 right-6 bg-primary-red text-white p-3 rounded-full shadow-lg hover:bg-primary-red-dark transition-colors"
        aria-label="Back to top"
      >
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
        </svg>
      </button>
    </footer>
  );
};

export default Footer;
